import Home from '@/views/tuyere'

// 路由配置表
/**
 * 路由参数meta详解
 * title          页面标题
 * whiteAuth      是否白名单（即不需登录）
 *
 */
const descovery = [
  // 首页
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页',
      // whiteAuth: true
    }
  },
  // 风口
  {
    path: '/:lang?/tuyere',
    name: 'Tuyere',
    component: () => import(/* webpackChunkName: "tuyere" */ '@/views/tuyere'),
    meta: {
      // whiteAuth: true
    }
  },
  // 我的行情
  {
    path: '/:lang?/my-market',
    name: 'MyMarket',
    meta: {},
    component: () => import(/* webpackChunkName: "my-market" */ '@/views/my-market'),
  },
  {
    // 港美股、A股行情详情
    path:'/intro-quota',
    name:'intro-quota',
    meta: {
      whiteAuth: true
    },
    component: () => import(/* webpackChunkName: "my-market" */ '@/views/intro-quota'),
  },
  // 如何投资港美股
  {
    path: '/:lang?/how-to-invest',
    name: 'HowToInvest',
    meta: {
      whiteAuth: true
    },
    component: () => import(/* webpackChunkName: "how-to-invest" */ '@/views/how-to-invest'),
  },
  // 关于账号安全
  {
    path: '/:lang?/account-security/:type',
    name: 'AccountSecurity',
    meta: {
      whiteAuth: true
    },
    component: () => import(/* webpackChunkName: "account-security" */ '@/views/account-security'),
  },
  // 为何选择我们
  {
    path: '/:lang?/why-choose-us',
    name: 'WhyChooseUs',
    meta: {
      whiteAuth: true
    },
    component: () => import(/* webpackChunkName: "why-choose-us" */ '@/views/why-choose-us'),
  },
  // 如何存入资金
  {
    path: '/:lang?/how-the-gold',
    name: 'HowTheGold',
    meta: {
      whiteAuth: true
    },
    component: () => import(/* webpackChunkName: "how-the-gold" */ '@/views/how-the-gold'),
  },
  // 港股入门
  {
    path: '/:lang?/introduction-hk',
    name: 'IntroductionHk',
    redirect:'/introduction-stock/hk',
    meta: {
      whiteAuth: true
    },
    // component: () => import(/* webpackChunkName: "introduction-hk" */ '@/views/introduction-hk'),
  },
  // 美股入门
  {
    path: '/:lang?/introduction-usa',
    name: 'IntroductionUsa',
    meta: {
      whiteAuth: true
    },
    redirect:'/introduction-stock/usa',
    // component: () => import(/* webpackChunkName: "introduction-usa" */ '@/views/introduction-usa'),
  },
  // 中华通介绍
  {
    path: '/:lang?/introduction-cn',
    name: 'IntroductionCn',
    meta: {
      whiteAuth: true
    },
    redirect:'/introduction-stock/cn',
    // component: () => import(/* webpackChunkName: "introduction-cn" */ '@/views/introduction-cn'),
  },
  {
    path:'/introduction-stock',
    name:'introduction-stock',
    meta: {
      whiteAuth: true
    },
    redirect:'/introduction-stock/hk',
    component: () => import(/* webpackChunkName: "introduction-cn" */ '@/views/introduction-stock'),
    children:[
      {
        path:'cn',
        name:'stock-cn',
        meta: {
          whiteAuth: true
        },
        component: () => import(/* webpackChunkName: "introduction-cn" */ '@/views/introduction-cn'),
      },
      {
        path:'usa',
        name:'stock-usa',
        meta: {
          whiteAuth: true
        },
        component: () => import(/* webpackChunkName: "introduction-usa" */ '@/views/introduction-usa'),
      },
      {
        path:'hk',
        name:'stock-hk',
        meta: {
          whiteAuth: true
        },
        component: () => import(/* webpackChunkName: "introduction-hk" */ '@/views/introduction-hk'),
      }
    ]
  },
  // 我的客户经理
  {
    path: '/:lang?/account-manager',
    name: 'AccountManager',
    meta: {},
    component: () => import(/* webpackChunkName: "other" */ '@/views/account-manager'),
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  // },
  // 协议
  {
    path: '/:lang?/protocol/:code',
    name: 'Protocol',
    meta: { whiteAuth: true },
    component: () => import(/* webpackChunkName: "protocol" */ '@/views/protocol-page'),
  }
]

export default descovery